// 応募しない求人一覧
import axios from '@/plugins/axios';
import { endpoint } from '@/api/apiConstants';
import { FileDownload } from '@/types/request';

export const downloadFile = async (params: FileDownload) => {
  const res = await axios.post(endpoint.fileDownload, params, {responseType: 'blob'});
  return res;
};